import { useMemo } from 'react';
import { Redirect, Switch } from 'react-router-dom';
import { StaffListsRoute } from './StaffListsRoute';
import { GPSurgeries } from 'containers/staff/settings/lists/GPSurgeries';
import { ICBs } from 'containers/staff/settings/lists/ICBs';
import { OtherReferrers } from 'containers/staff/settings/lists/OtherReferrers';
import {
  STAFF_APPT_OPTIONS_URL,
  STAFF_GP_SURGERIES_URL,
  STAFF_GP_SURGERY_MERGE_URL,
  STAFF_ICBS_MERGE_URL,
  STAFF_ICBS_URL,
  STAFF_OTHER_REFERRERS_MERGE_URL,
  STAFF_OTHER_REFERRERS_URL,
} from 'routes/AppRoutes';
import { useSite } from 'context/SiteContext';
import { ICBsMerge } from 'containers/staff/settings/lists/ICBsMerge';
import { GPSurgeriesMerge } from 'containers/staff/settings/lists/GPSurgeriesMerge';
import { OtherReferrersMerge } from 'containers/staff/settings/lists/OtherReferrersMerge';
import { isGpSurgeryRequired } from 'utils/siteUtils';
import { ApptOptions } from 'containers/staff/settings/lists/ApptOptions';
import { SHOW_APPT_OPTIONS } from 'configs/siteAndTrustAttributes';
import { useSiteBooleanAttributes } from 'hooks/useAttribute';

export const StaffListsSwitch = () => {
  const { activeSite } = useSite();
  const [showApptOptions] = useSiteBooleanAttributes(SHOW_APPT_OPTIONS);
  const otherReferrerOnly = useMemo(
    () => !isGpSurgeryRequired(activeSite),
    [activeSite],
  );
  return (
    <Switch>
      <StaffListsRoute
        exact
        path={STAFF_GP_SURGERIES_URL}
        render={() => <GPSurgeries />}
      />
      <StaffListsRoute exact path={STAFF_ICBS_URL} render={() => <ICBs />} />
      <StaffListsRoute
        exact
        path={STAFF_OTHER_REFERRERS_URL}
        render={() => <OtherReferrers />}
      />
      <StaffListsRoute
        exact
        path={STAFF_GP_SURGERY_MERGE_URL}
        render={() => <GPSurgeriesMerge />}
      />
      <StaffListsRoute
        exact
        path={STAFF_ICBS_MERGE_URL}
        render={() => <ICBsMerge />}
      />
      <StaffListsRoute
        exact
        path={STAFF_OTHER_REFERRERS_MERGE_URL}
        render={() => <OtherReferrersMerge />}
      />
      {showApptOptions && (
        <StaffListsRoute
          exact
          path={STAFF_APPT_OPTIONS_URL}
          render={() => <ApptOptions />}
        />
      )}
      <Redirect
        to={
          otherReferrerOnly ? STAFF_OTHER_REFERRERS_URL : STAFF_GP_SURGERIES_URL
        }
      />
    </Switch>
  );
};
